export default {"src":"/_next/static/media/collective-purchase.a1fe6c59.svg","height":24,"width":24};